import type { RowProps } from "components/Row";
import { Row } from "components/Row";
import type { ReactStoryblokComponent } from "types/storyblok";

const RowAdapter = ({
  blok: {
    pyMobile,
    mtMobile,
    pyDesktop,
    mtDesktop,
    mbMobile,
    mbDesktop,
    bgStyle,
    id,
    display,
    content,
    pxMobile,
    pxDesktop,
    pyTablet,
    mtTablet,
    mbTablet,
    pxTablet,
  },
  sbEditable,
}: ReactStoryblokComponent<RowProps>) => (
  <Row
    pyMobile={pyMobile}
    mtMobile={mtMobile}
    pxMobile={pxMobile || "16px"}
    mbMobile={mbMobile}
    pyTablet={pyTablet}
    mtTablet={mtTablet}
    mbTablet={mbTablet}
    pxTablet={pxTablet}
    pyDesktop={pyDesktop}
    mtDesktop={mtDesktop}
    mbDesktop={mbDesktop}
    pxDesktop={pxDesktop}
    bgStyle={bgStyle}
    id={id}
    display={display}
    content={content}
    sbEditable={sbEditable}
  />
);

export default RowAdapter;
